'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.makeIntIsInRange = exports.makeHasMinLength = exports.makeHasMaxLength = exports.isAWholeNumber = exports.isANumber = exports.isAnInteger = exports.makeMatchesRegex = exports.makeIsOneOf = exports.hasContent = exports.isProvided = undefined;

var _isString = require('lodash/isString');

var _isString2 = _interopRequireDefault(_isString);

var _isBoolean = require('lodash/isBoolean');

var _isBoolean2 = _interopRequireDefault(_isBoolean);

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Validator: Tests that the value is present and not empty. Useful for `required`.
 *
 * @param value
 * @returns {boolean}
 */
var isProvided = exports.isProvided = function isProvided(value) {
    var result = void 0;

    if ((0, _isString2.default)(value)) {
        result = Boolean(value.trim());
    } else if ((0, _isBoolean2.default)(value)) {
        result = value;
    } else {
        result = !(0, _isEmpty2.default)(value);
    }

    return result;
};

/**
 * Validator: Ensures that the inputted string is not entirely spaces.
 *
 * @param value {string}
 * @returns {boolean}
 */
/*
 __________________________________
/ This is a good place for general \
\ purpose validators               /
 ----------------------------------
        \   ^__^
         \  (oo)\_______
            (__)\       )\/\
                ||----w |
                ||     ||

In this context:

    VALIDATOR (noun) -  A function that takes returns a boolean describing the validity of a given value.
                        Validators' names should be predicates.

    GENERATOR (noun) -  A function that takes parameters then MAKEs and returns a VALIDATOR.
                        Generators' names should start with `make` for consistency.

Most validators should treat empty or missing values as VALID.

*/
var hasContent = exports.hasContent = function hasContent(value) {
    return !value || value.trim() !== '';
};

/**
 * Generator: Makes an isOneOf validator.
 * Validator: Tests that the value is one of the elements in `list`
 *
 * @param list {array}
 * @returns {function}
 */
var makeIsOneOf = exports.makeIsOneOf = function makeIsOneOf() {
    var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return function (value) {
        return list.includes(value);
    };
};

/**
 * Generator: Makes a matchesRegex validator.
 * Validator: Tests that the value satisfies the `regexPattern`s `test` method.
 *
 * @param regexPattern
 * @returns {function}
 */
var makeMatchesRegex = exports.makeMatchesRegex = function makeMatchesRegex(regexPattern) {
    return function (value) {
        return !value || regexPattern.test('' + value);
    };
};

/**
 * Validator: Tests that the value is an integer
 *
 * @param value
 * @returns {boolean}
 */
var isAnInteger = exports.isAnInteger = makeMatchesRegex(/^(-{1})?[0-9]+(\.0*)?(?:e[+-][0-9]+)?$/);

/**
 * Validator: Tests that the value is an integer
 *
 * @param value
 * @returns {boolean}
 */
var isANumber = exports.isANumber = makeMatchesRegex(/^(?:[0-9]+|[0-9]*\.[0-9]+)(?:e[+-][0-9]+)?$/);

/**
 * Validator: Tests that the value is a whole number
 *
 * @param value
 * @returns {boolean}
 */
var isAWholeNumber = exports.isAWholeNumber = function isAWholeNumber(value) {
    return !value || isAnInteger(value) && parseInt(value, 10) >= 0;
};

/**
 * Generator: Makes a hasMaxLength validator.
 * Validator: Tests that the value's length is equal to or shorter than `maxLength`.
 *
 * @param maxLength
 * @returns {function}
 */
var makeHasMaxLength = exports.makeHasMaxLength = function makeHasMaxLength(maxLength) {
    return function (value) {
        return !value || value.length <= maxLength;
    };
};

/**
 * Generator: Makes a hasMinLength validator.
 * Validator: Tests that the value's length is equal to or longer than `minLength`.
 *
 * @param minLength
 * @returns {function}
 */
var makeHasMinLength = exports.makeHasMinLength = function makeHasMinLength(minLength) {
    return function (value) {
        return !value || value.length >= minLength;
    };
};

/**
 * Generator: Makes an isInRange validator.
 * Validator: Tests that the value is within a range (inclusive)
 *
 * @param low - bottom end of range
 * @param high - top end of range
 * @returns {function}
 */
var makeIntIsInRange = exports.makeIntIsInRange = function makeIntIsInRange(low, high) {
    return function (value) {
        if (!value) {
            return true;
        }

        var intValue = parseInt(value, 10);
        var intLow = parseInt(low, 10);
        var intHigh = parseInt(high, 10);

        return intValue >= intLow && intValue <= intHigh;
    };
};